import React from "react";
const RenderIcons = ({ value }) => {
  return (
    <>
      <i style={{ stroke: "currentColor" }}>{value}</i>
    </>
  );
};

export default RenderIcons;
